module.exports = __webpack_public_path__ + "img/pincodeLoginLeftImg.6d182cb8.svg";